import React from 'react';
import { NavLink } from 'react-router-dom';
import classNames from 'classnames';
import janeliaLogo from '../images/janelia_logo.png';
import './Navigation.css';

class Navigation extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      navShow: false,
    };
  }

  handleToggleNav = () => {
    const current = this.state.navShow;
    this.setState({ navShow: !current });
  }

  handleCloseNav = () => {
    this.setState({ navShow: false });
  }

  render() {
    const navClass = classNames({
      collapse: true,
      'navbar-collapse': true,
      show: this.state.navShow,
    });

    return (
      <nav className="navbar navbar-expand-lg navbar-dark bg-dark sticky-top">
        <NavLink to="/" className="navbar-brand" onClick={this.handleCloseNav}>ThalamoSeq</NavLink>
        <button className="navbar-toggler" type="button" data-toggle="collapse" data-target="#navbarTogglerDemo02" aria-controls="navbarTogglerDemo02" aria-expanded="false" aria-label="Toggle navigation">
          <span className="navbar-toggler-icon" onClick={this.handleToggleNav} />
        </button>

        <div className={navClass} >
          <ul className="navbar-nav mr-auto mt-2 mt-lg-0">
            <li className="nav-item">
              <NavLink exact className="nav-link" to="/" onClick={this.handleCloseNav}> Home </NavLink>
            </li>
            <li className="nav-item">
              <NavLink className="nav-link" to="/nuclei" onClick={this.handleCloseNav}>Nuclei Data</NavLink>
            </li>
            <li className="nav-item">
              <NavLink className="nav-link" to="/single-cell" onClick={this.handleCloseNav}>Single Cell Data</NavLink>
            </li>
            <li className="nav-item">
              <NavLink className="nav-link" to="/about" onClick={this.handleCloseNav}>About</NavLink>
            </li>
            <li className="nav-item">
              <NavLink className="nav-link" to="/download" onClick={this.handleCloseNav}>Download</NavLink>
            </li>
          </ul>
          <a href="https://janelia.org" className="my-2 my-lg-0">
            <img alt="janeliaLogo" src={janeliaLogo} className="janeliaLogo" />
          </a>
        </div>
      </nav>
    );
  }
}

export default Navigation;



// WEBPACK FOOTER //
// ./src/components/Navigation.jsx